<div class="container" [style.left]="styleLeft" [style.top]="styleTop">
    <p>{{data.name}}</p>
</div>
